import { useLibraryIdentity } from "@/hooks/useLibraryIdentity";
import { EXPANSION_PROVIDERS, expansionVisible } from "@/lib/expansion";

/** Public gates stay unchanged; read validation uses the existing verified account cohort. */
export function useExpansionConnectionAccess() {
  const identity = useLibraryIdentity();
  const userId = identity.ready && !identity.error ? identity.userId : null;
  const providers = EXPANSION_PROVIDERS.filter(provider => expansionVisible(provider, userId));
  return {
    ...identity, userId, providers,
    dropboxEnabled: providers.includes("dropbox"),
    todoistEnabled: providers.includes("todoist"),
    trelloEnabled: providers.includes("trello"),
    slackEnabled: providers.includes("slack"),
    microsoftTeamsEnabled: providers.includes("microsoft_teams"),
  };
}
